import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import ReactGA from "react-ga4";
import { ChimeraSlave } from "./chimera/ChimeraSlave";
import { ChimeraProvider } from "./chimera/ChimeraContext";
import { setChimeraProvider, setupAxiosInterceptor } from "./utils/axiosConfig";
//import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

ReactGA.initialize("G-MKNNGELRSE");

const queryClient = new QueryClient();

let chimeraProvider = null;

(async () => {
  try {
    chimeraProvider = new ChimeraSlave(window.parent);
    
    const isConnected = await chimeraProvider.init();
    
    if (isConnected) {
      console.log('Mobstr success connected to the Chimera');
    } else {
      console.log('Mobstr is working in the standalone mode');
    }
    
    setChimeraProvider(chimeraProvider);
    setupAxiosInterceptor();
    
    window.chimeraProvider = chimeraProvider;
    
  } catch (error) {
    console.error('Failed to init Chimera:', error);
    setupAxiosInterceptor();
  }
  
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ChimeraProvider chimeraProvider={chimeraProvider}>
          <App chimeraProvider={chimeraProvider} />
          {/* //<ReactQueryDevtools initialIsOpen={false} /> */}
        </ChimeraProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
  
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
  
})().catch((error) => {
  console.error('Failed to run app:', error);
});
